/**
 *
 * Usage:
 *
 *   data-sw-force-pattern
 *   pattern="<REGEX_PATTERN_TO_MATCH>" last value applied on RegEx fail 
 *
 *
 */

var $ = require('./../sw-jquery');

var attrSelector = '[data-sw-force-pattern]';
var lastValueDataAttr = 'swForcePatternLastValue';

$(function() {
  var $body = $('body');
  
  $body.on('input', attrSelector, function() {
    var $el = $(this);
    var val = $el.val();
    var lastVal = $el.data(lastValueDataAttr);

    if ($el.swValidatePattern()) {
      $el.data(lastValueDataAttr, val);
    } else {
      $el.val(lastVal);
    }
  });

  $body.on('focus', attrSelector, function() {
    var $el = $(this);
    $el.data(lastValueDataAttr, $el.val());
  });
});
